import useUtilities from '_helpers/useUtilities';
import React, { ReactElement, useEffect } from 'react';

const AutoFocusableElement:React.FC<{selector:string, children:ReactElement}> = ({selector,children}) => {
    const { setElementFocusBySelector } = useUtilities();
    
    useEffect(() => {
        setElementFocusBySelector(selector);      
    }, []);

    return(
        <>
            {children}
        </>
    );    
}

export default AutoFocusableElement;